// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wEE_","colMin":"styles_colMin__27RcK"};